// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__WWinW","approved":"Status_approved__36-HW","rejected":"Status_rejected__3i8Z2","expired":"Status_expired__3n-PM","label":"Status_label__23lNz"};